module.exports = __webpack_public_path__ + "img/prize-01.a132c1f2.png";